<template>
    <div class="bg-white" style="height:100vh">
        <CContainer style="max-width:500px">
            <br />
            <CRow class="p-2">
                <div style="width:10%" @click="goBack">
                    <img src="../assets/img/arrow-left.png" width="20px" />
                </div>
                <div style="width:90%">
                    <div class="text-center">
                        <h3 class="custom-20px-600">e-Voucher</h3>
                    </div>
                </div>
                <div style="width:100%">
                    <h3 class="custom-14px-600 font-color-241F21 text-left mt-2">
                        Link
                    </h3>
                    <CRow v-for="item in brands" v-bind:key="item.Id">
                        <CCol sm="12">
                           <CCard class="p-1">
                            <a :href="item.QuestionLink" target="_blank">{{ item.QuestionLink }}</a></CCard>
                        </CCol>
                    </CRow>
                </div>
    
    
            </CRow>
        </CContainer>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import _ from "lodash";
Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import ToggleCard from '../components/Toggle.vue';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        ToggleCard,
        PulseLoader

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,

            brands: [],
            SelectedBrand: ""






        }

    },
    async mounted() {

        this.getListBrand();

    },


    methods: {
        async getListBrand() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListBrandVoucher + "?userId=" + this.$route.query.companyId);
                if (response.status === 200) {
                    this.Busy = false;
                    this.brands = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        goBack() {
        this.$router.go(-1); // This will navigate to the previous page
    }






    }

};
</script>